var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "interface-area listing" }, [
    _c("div", { staticClass: "transaction-box" }, [
      _c("div", { staticClass: "text-area" }, [
        _c("h1", [
          _vm._v("\n        " + _vm._s(_vm.$t("listing.listing")) + "\n      "),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "desc" }, [
          _vm._v(
            "\n        " + _vm._s(_vm.$t("listing.listing_desc")) + "\n      "
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "buttons-area" }, [
          _vm.user !== undefined && _vm.user !== null
            ? _c(
                "button",
                {
                  staticClass: "btn cyan",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.scrolltoForm("new")
                    },
                  },
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("listing.create_new")) +
                      "\n        "
                  ),
                ]
              )
            : _c(
                "button",
                {
                  staticClass: "btn pink",
                  attrs: { type: "button" },
                  on: { click: _vm.openConnectModal },
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("common.connect_wallet")) +
                      "\n        "
                  ),
                ]
              ),
          _vm._v(" "),
          _vm.user !== undefined && _vm.user !== null
            ? _c(
                "button",
                {
                  staticClass: "btn pink",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.scrolltoForm("exists")
                    },
                  },
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("listing.add_by_address")) +
                      "\n        "
                  ),
                ]
              )
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "image-area" }, [
        _c("div", { staticClass: "picture" }, [
          _c(
            "picture",
            [
              _c("source", {
                attrs: {
                  srcset: "/img/new/coins/left-2.webp",
                  type: "image/webp",
                },
              }),
              _vm._v(" "),
              _c("nuxt-img", {
                attrs: {
                  fit: "inside",
                  src: "/img/new/coins/left-2.png",
                  alt: "Deposit USDT and buy $DFP to invest n Defi Pool Finance",
                  title: "Invest in $DFP",
                  loading: "lazy",
                  placeholder: "",
                  quality: 80,
                },
              }),
            ],
            1
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "listing-area" }, [
      _c("div", { staticClass: "preview-area" }, [
        _c("div", { staticClass: "preview-title" }, [
          _vm._v("\n        " + _vm._s(_vm.$t("listing.preview")) + "\n      "),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "image-area" },
          [
            _c("nuxt-img", {
              attrs: {
                src: _vm.$getImage(_vm.form.image),
                alt:
                  _vm.form.name !== null && _vm.form.name.length > 0
                    ? _vm.form.name +
                      " crypto token creation and sell fo free on DefiPool"
                    : "Creating new crypto token with price for the makret on Defi Pool",
                title:
                  _vm.form.name !== null && _vm.form.name.length > 0
                    ? _vm.form.name
                    : "New ERC20 token on Defi Pool",
                fit: "inside",
                loading: "lazy",
                placeholder: "",
              },
              on: {
                error: function ($event) {
                  $event.target.src = require("~/static/img/default_token.svg")
                },
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "text-area" }, [
          _c("div", { staticClass: "title" }, [
            _vm._v(
              "\n          " +
                _vm._s(
                  _vm.form.name !== null && _vm.form.name.length > 0
                    ? _vm.form.name
                    : _vm.$t("listing.new_token")
                ) +
                "\n          (" +
                _vm._s(
                  _vm.form.symbol !== null && _vm.form.symbol.length > 0
                    ? _vm.form.symbol
                    : _vm.$t("listing.new_token_symbol")
                ) +
                ")\n        "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "value-area" }, [
            _c("span", { staticClass: "value" }, [
              _vm._v(
                "\n            " +
                  _vm._s(
                    _vm.form.decimals !== null && _vm.form.decimals.length > 0
                      ? _vm.form.decimals
                      : "18"
                  ) +
                  "\n          "
              ),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "desc" }, [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$t("listing.decimals_word")) +
                  "\n          "
              ),
            ]),
          ]),
          _vm._v(" "),
          _vm.form.hard_cap !== null && _vm.form.hard_cap.toString().length > 0
            ? _c("div", { staticClass: "value-area" }, [
                _c("span", { staticClass: "value" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$priceFormat(_vm.form.hard_cap, 0)) +
                      "\n          "
                  ),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "desc" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("listing.hard_cap_word")) +
                      "\n          "
                  ),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.form.address !== null &&
          _vm.form.address.length > 0 &&
          _vm.$isAddress(_vm.form.address)
            ? _c("div", { staticClass: "chain-explorer" }, [
                _c(
                  "a",
                  {
                    attrs: {
                      href: _vm.$getExplorerUserLink(_vm.form.address),
                      rel: "nofollow noopener noreferrer",
                      target: "_blank",
                    },
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("listing.view_on_explorer")) +
                        "\n            "
                    ),
                    _c("i", { staticClass: "bx bx-link-external" }),
                  ]
                ),
              ])
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { ref: "listingForm", staticClass: "listing-form" }, [
        _c("div", { staticClass: "form-area" }, [
          _vm.form.method === "new" && _vm.form.step === 1
            ? _c("div", { staticClass: "form-content create-token" }, [
                _c("div", { staticClass: "title" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("listing.create_new_header")) +
                      "\n          "
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "desc" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("listing.create_new_desc")) +
                      "\n          "
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "input-area" }, [
                  _c("p", { staticClass: "input-header" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.$t("listing.name")) +
                        "\n              "
                    ),
                    _c("span", { staticClass: "required" }, [
                      _vm._v("\n                *\n              "),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "input-container" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.name,
                          expression: "form.name",
                        },
                      ],
                      staticClass: "input",
                      attrs: { type: "text" },
                      domProps: { value: _vm.form.name },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.form, "name", $event.target.value)
                        },
                      },
                    }),
                    _vm._v(" "),
                    _vm.errors.name.length > 0
                      ? _c("p", { staticClass: "hint error" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.errors.name) +
                              "\n              "
                          ),
                        ])
                      : _vm._e(),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "input-area" }, [
                  _c("p", { staticClass: "input-header" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.$t("listing.symbol")) +
                        "\n              "
                    ),
                    _c("span", { staticClass: "required" }, [
                      _vm._v("\n                *\n              "),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "input-container" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.symbol,
                          expression: "form.symbol",
                        },
                      ],
                      staticClass: "input",
                      attrs: { type: "text" },
                      domProps: { value: _vm.form.symbol },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.form, "symbol", $event.target.value)
                        },
                      },
                    }),
                    _vm._v(" "),
                    _vm.errors.symbol.length > 0
                      ? _c("p", { staticClass: "hint error" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.errors.symbol) +
                              "\n              "
                          ),
                        ])
                      : _vm._e(),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "input-area" }, [
                  _c("p", { staticClass: "input-header" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.$t("listing.decimals")) +
                        "\n              "
                    ),
                    _c("span", { staticClass: "required" }, [
                      _vm._v("\n                *\n              "),
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "hint wide-tooltip",
                        attrs: { tooltip: _vm.$t("listing.decimals_tip") },
                      },
                      [_c("i", { staticClass: "bx bxs-info-circle" })]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "input-container" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.decimals,
                          expression: "form.decimals",
                        },
                      ],
                      staticClass: "input",
                      attrs: { type: "number" },
                      domProps: { value: _vm.form.decimals },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.form, "decimals", $event.target.value)
                        },
                      },
                    }),
                    _vm._v(" "),
                    _vm.errors.decimals.length > 0
                      ? _c("p", { staticClass: "hint error" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.errors.decimals) +
                              "\n              "
                          ),
                        ])
                      : _vm._e(),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "input-area" }, [
                  _c("p", { staticClass: "input-header" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.$t("listing.hard_cap")) +
                        "\n              "
                    ),
                    _c(
                      "span",
                      {
                        staticClass: "hint wide-tooltip",
                        attrs: { tooltip: _vm.$t("listing.hard_cap_tip") },
                      },
                      [_c("i", { staticClass: "bx bxs-info-circle" })]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "input-container" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.hard_cap,
                          expression: "form.hard_cap",
                        },
                      ],
                      staticClass: "input",
                      attrs: { type: "number" },
                      domProps: { value: _vm.form.hard_cap },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.form, "hard_cap", $event.target.value)
                        },
                      },
                    }),
                    _vm._v(" "),
                    _vm.errors.hard_cap.length > 0
                      ? _c("p", { staticClass: "hint error" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.errors.hard_cap) +
                              "\n              "
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.form.hard_cap !== null &&
                    _vm.form.hard_cap.length > 0 &&
                    parseInt(_vm.form.hard_cap, 10) !== 0
                      ? _c("p", { staticClass: "hint info" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.$t("listing.hard_cap_notice")) +
                              "\n              "
                          ),
                        ])
                      : _vm._e(),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "buttons-area" }, [
                  _vm.user !== null
                    ? _c(
                        "button",
                        {
                          class: {
                            "btn pink": true,
                            disabled: _vm.form.loading,
                          },
                          attrs: { type: "button", disabled: _vm.form.loading },
                          on: { click: _vm.deployToken },
                        },
                        [
                          !_vm.form.loading
                            ? _c("span", [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.$t("listing.deploy")) +
                                    "\n              "
                                ),
                              ])
                            : _c("span", [
                                _c("i", {
                                  staticClass: "bx bx-loader-alt loading",
                                }),
                              ]),
                        ]
                      )
                    : _c(
                        "button",
                        {
                          staticClass: "btn pink",
                          on: { click: _vm.openConnectModal },
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("common.connect_wallet")) +
                              "\n            "
                          ),
                        ]
                      ),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.form.method === "exists" && _vm.form.step === 1
            ? _c("div", { staticClass: "form-content add-token" }, [
                _c("div", { staticClass: "title" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("listing.add_by_address_header")) +
                      "\n          "
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "desc" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("listing.add_by_address_desc")) +
                      "\n          "
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "input-area" }, [
                  _c("p", { staticClass: "input-header" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.$t("listing.address")) +
                        "\n              "
                    ),
                    _c("span", { staticClass: "required" }, [
                      _vm._v("\n                *\n              "),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "input-container" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.address,
                          expression: "form.address",
                        },
                      ],
                      staticClass: "input",
                      attrs: { type: "text" },
                      domProps: { value: _vm.form.address },
                      on: {
                        input: [
                          function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(_vm.form, "address", $event.target.value)
                          },
                          _vm.checkAddressField,
                        ],
                      },
                    }),
                    _vm._v(" "),
                    _vm.errors.address.length > 0
                      ? _c("p", { staticClass: "hint error" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.errors.address) +
                              "\n              "
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.form.address !== null && _vm.form.address.length > 0
                      ? _c("p", { staticClass: "hint info" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.$t("listing.add_by_address_notice")) +
                              "\n              "
                          ),
                        ])
                      : _vm._e(),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "buttons-area" }, [
                  _vm.user !== null
                    ? _c(
                        "button",
                        {
                          class: {
                            "btn pink": true,
                            disabled: _vm.hasErrors || _vm.form.loading,
                          },
                          attrs: {
                            type: "button",
                            disabled: _vm.hasErrors || _vm.form.loading,
                          },
                          on: { click: _vm.checkErc20Address },
                        },
                        [
                          !_vm.form.loading
                            ? _c("span", [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.$t("listing.fetch")) +
                                    "\n              "
                                ),
                              ])
                            : _c("span", [
                                _c("i", {
                                  staticClass: "bx bx-loader-alt loading",
                                }),
                              ]),
                        ]
                      )
                    : _c(
                        "button",
                        {
                          staticClass: "btn pink",
                          on: { click: _vm.openConnectWallet },
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("common.connect_wallet")) +
                              "\n            "
                          ),
                        ]
                      ),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.form.step === 2
            ? _c("div", { staticClass: "form-content image" }, [
                _c("div", { staticClass: "title" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("listing.upload_image")) +
                      "\n          "
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "desc" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("listing.upload_image_desc")) +
                      "\n          "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "image-area" },
                  [
                    _c(
                      "client-only",
                      [
                        _c("FilePond", {
                          ref: "image",
                          staticClass: "filepond",
                          attrs: {
                            "label-idle": _vm.$t("listing.image_placeholder"),
                            "allow-multiple": false,
                            "allow-process": false,
                            "accepted-file-types":
                              "image/jpeg, image/png, image/gif, image/webp",
                            "max-file-size": "2MB",
                            "label-max-file-size-exceeded": _vm.$t(
                              "listing.media_is_too_large"
                            ),
                            "label-max-file-size": _vm.$t(
                              "listing.max_file_size",
                              { max: "2MB" }
                            ),
                            server: _vm.imageServerOptions,
                            files: _vm.fileImage,
                          },
                          on: {
                            init: _vm.initImage,
                            initfile: _vm.activateImageDelete,
                            removefile: _vm.deactivateImageDelete,
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("p", { staticClass: "desc" }, [
                  _vm._v(
                    "\n            JPG, PNG, GIF, WEBP. " +
                      _vm._s(_vm.$t("listing.max_size")) +
                      ": 2 MB\n          "
                  ),
                ]),
                _vm._v(" "),
                _vm.imageCanDelete
                  ? _c("label", { staticClass: "delete-area" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn cyan smaller",
                          attrs: { type: "button" },
                          on: { click: _vm.emptyImage },
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("listing.delete_image")) +
                              "\n            "
                          ),
                        ]
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "buttons-area" }, [
                  _vm.user !== null
                    ? _c(
                        "button",
                        {
                          class: {
                            "btn pink": true,
                            disabled: _vm.hasErrors || _vm.form.loading,
                          },
                          attrs: {
                            type: "button",
                            disabled: _vm.hasErrors || _vm.form.loading,
                          },
                          on: { click: _vm.goNextPage },
                        },
                        [
                          !_vm.form.loading
                            ? _c("span", [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.$t("listing.next")) +
                                    "\n              "
                                ),
                              ])
                            : _c("span", [
                                _c("i", {
                                  staticClass: "bx bx-loader-alt loading",
                                }),
                              ]),
                        ]
                      )
                    : _vm._e(),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.form.step === 3
            ? _c("div", { staticClass: "form-content liquidity" }, [
                _c("div", { staticClass: "title" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("listing.add_liquidity_header")) +
                      "\n          "
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "desc" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("listing.add_liquidity_desc")) +
                      "\n          "
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "buttons-area" }, [
                  _c(
                    "button",
                    {
                      class: {
                        "btn pink": true,
                        disabled: _vm.hasErrors || _vm.form.loading,
                      },
                      attrs: {
                        type: "button",
                        disabled: _vm.hasErrors || _vm.form.loading,
                      },
                      on: { click: _vm.fixTokenToLiquidity },
                    },
                    [
                      _c("span", [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.$t("listing.add_liquidity")) +
                            "\n              "
                        ),
                      ]),
                    ]
                  ),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.form.step === 4
            ? _c("div", { staticClass: "form-content success" }, [
                _c("div", { staticClass: "title" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.$t("listing.success", { token: _vm.form.name })
                      ) +
                      " 🎉\n          "
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "desc" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("listing.success_desc")) +
                      "\n          "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "buttons-area" },
                  [
                    _c(
                      "nuxt-link",
                      {
                        class: {
                          "btn pink": true,
                          disabled: _vm.hasErrors || _vm.form.loading,
                        },
                        attrs: {
                          to: _vm.localePath("/swap"),
                          disabled: _vm.hasErrors || _vm.form.loading,
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.$t("listing.continue_to_site")) +
                              "\n              "
                          ),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "steps" },
          _vm._l(_vm.steps, function (ind) {
            return _c("div", {
              key: ind,
              class: { step: true, active: _vm.form.step === ind },
            })
          }),
          0
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }